import React, { FC } from 'react'
import { ResourceItem } from '../style'
import { ImageContainer, TextContainer } from './containers'

//* utils
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { UseCases } from '../../../../constants/useCases.constants'
import { isExternalURL } from '../../../../utils/link.utils'
import VideoPlayer from '../../videoPlayer'
import { getCardDetails, getPageLink, getTimeAndCta } from '../utils/helper'

type Props = {
  item: any
  resourceRowData: any
  isHomePage: boolean
  locale: string
  index: number
}

export const GenerateCard: FC<Props> = ({ item, resourceRowData, isHomePage, locale, index }) => {
  const {
    itemData,
    assets,
    categoryIcon,
    companyLogo,
    videoIcon,
    companyAltText,
    categoryAltText,
  } = getCardDetails(item, resourceRowData, isHomePage)
  if (!itemData) return null
  const { ctaText, when, convertedDate, datePassed } = getTimeAndCta(itemData, resourceRowData)
  const linkTarget = isExternalURL(itemData.pageLink) ? '_blank' : '_self'
  const pageLink = getPageLink(item)

  const finalCtaText =
    item.__typename === ModuleNames.TOPIC_CARD || item.__typename === 'topicCard'
      ? itemData.ctaText
      : ctaText

  const includedDateCategory =
    itemData.category.title === UseCases.RESOURCE_LISTING_WEBINAR ||
    itemData.category.title === UseCases.RESOURCE_LISTING_EVENTS

  if (item.video?.youtubeId) {
    itemData.tcVideo.id = item.video.youtubeId
    itemData.tcVideo.type = 'youtube'
  }

  if (item.video?.vimeoId) {
    itemData.tcVideo.id = item.video.vimeoId
    itemData.tcVideo.type = 'vimeo'
  }

  if (item.video?.videoUrl) {
    itemData.tcVideo.url = item.video.videoUrl
    itemData.tcVideo.type = 'html-video'
  }

  if (item.video?.tencentVideoUrl) {
    itemData.tcVideo.url = item.video.tencentVideoUrl
    itemData.tcVideo.type = 'tencent-video'
  }

  const videoOverlayData = {
    video: itemData?.tcVideo,
    imageUrl: itemData?.image?.url,
    imgAlt: itemData?.image?.altText,
  }

  const tcVideoStatus = itemData.tcVideo.id || itemData.tcVideo.url || ''

  const renderVideoOverlay = (videoData: any) => {
    return (
      <VideoPlayer
        width={'100%'}
        height="auto"
        videoId={videoData.video.id}
        videoUrl={videoData.video.url}
        type={videoData.video.type}
        img={videoData.imageUrl ? videoData.imageUrl : videoData.video.image}
        backgroundAltText={videoData?.video?.altText}
        backgroundImgParams={'width=732'}
        start={videoData.video.start}
        animationFileUrl={videoData.video.animationFile}
        imageOverlay={videoData?.video?.imageOverlay}
      />
    )
  }

  return (
    <ResourceItem
      className={tcVideoStatus ? 'ResourceRow__Item tcVideo' : 'ResourceRow__Item'}
      $hasOverlay={!!assets.image.url}
      $videoIcon={videoIcon}
      $companyLogo={companyLogo}
      $categoryIcon={categoryIcon}
      $imageOverlay={videoOverlayData?.video?.imageOverlay}>
      {tcVideoStatus ? (
        <>
          <div
            className={
              resourceRowData.noMedia === true
                ? 'ResourceRow__Item-Video noMediaContainer'
                : 'ResourceRow__Item-Video'
            }>
            {renderVideoOverlay(videoOverlayData)}
          </div>
        </>
      ) : (
        <a
          href={isExternalURL(itemData.pageLink) ? itemData.pageLink : pageLink}
          target={isExternalURL(itemData.pageLink) ? '_blank' : '_self'}></a>
      )}

      {!resourceRowData.noMedia && !tcVideoStatus && (
        <ImageContainer
          itemData={itemData}
          assets={assets}
          companyLogo={companyLogo}
          companyAltText={companyAltText}
          videoIcon={videoIcon}
          categoryIcon={categoryIcon}
          categoryAltText={categoryAltText}
          locale={locale}
          when={when || ''}
          resourceRowData={resourceRowData}
        />
      )}
      <TextContainer
        resourceRowData={resourceRowData}
        itemData={itemData}
        assets={assets}
        ctaText={finalCtaText}
        isHomePage={isHomePage}
        pageLink={pageLink}
        convertedDate={convertedDate}
        datePassed={datePassed || false}
        includedDateCategory={includedDateCategory || false}
        locale={locale}
      />
    </ResourceItem>
  )
}
